import { createRoutes } from 'shared/hocs'

import { ConfirmPassword } from './confirmPassword'
import { ResetPassword } from './resetPassword'
import Signup from './signup'
import PreSignup from './signupBene'
import PreSignupBeneConfirm from './signupBeneConfirm'
import PreSignupSponsorConfirm from './signupSponsorConfirm'
import PreSignupSponsor from './signupSponsor'
import Login from './login'
import NewLogin from './newLogin'
import NewSignup from './newSignup'

const AuthRoutes = createRoutes(({ match }) => [
  {
    path: `${match.path}/signup2`,
    component: Signup,
  },
  {
    path: `${match.path}/signup`,
    component: NewSignup,
  },
  {
    path: `${match.path}/pre-signup-beneficiary`,
    exact: true,
    component: PreSignup,
  },
  {
    path: `${match.path}/pre-signup-beneficiary/:token/confirm`,
    exact: true,
    component: PreSignupBeneConfirm,
  },
  {
    path: `${match.path}/pre-signup-partner`,
    exact: true,
    component: PreSignupSponsor,
  },
  {
    path: `${match.path}/pre-signup-partner/:token/confirm`,
    exact: true,
    component: PreSignupSponsorConfirm,
  },
  {
    path: `${match.path}/login2`,
    component: Login,
  },
  {
    path: `${match.path}/login`,
    component: NewLogin,
  },
  {
    path: `${match.path}/reset`,
    component: ResetPassword,
  },
  {
    path: `${match.path}/confirm`,
    component: ConfirmPassword,
  },
])

export default AuthRoutes
